import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../../_models/garantias-idoneas';
import {ListaService} from '../../../_services/lista.service';
import {NavService} from '../../../_services/_nav.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {GarantiasIdoneasPeriodoGracia} from '../../../_models/garantias-idoneas-periodo-gracia';
import {ConceptoFacturacion} from '../../../_models/concepto-facturacion';
import {GarantiaIdoneasPeriodoGraciaService} from '../../../_services/garantia-idoneas-periodo-gracia.service';
import {GarantiaIdoneasPeriodoGraciaConceptosFacturacionService} from '../../../_services/garantia-idoneas-periodo-gracia-conceptos-facturacion.service';
import {ConceptoFacturacionService} from '../../../_services/concepto-facturacion.service';
import {GarantiasIdoneasPeriodoGraciaConceptoFacturacion} from '../../../_models/garantias-idoneas-periodo-gracia-concepto-facturacion';
import {ListaItem} from '../../../_models/lista-item';

@Component( {
  selector: 'app-garantia-idoneas-periodo-gracia',
  templateUrl: 'garantia-idoneas-periodo-gracia.component.html'
} )

export class GarantiaIdoneasPeriodoGraciaComponent implements OnInit {

  formulario: FormGroup;
  formularioConceptos: FormGroup;

  /** items */
  @Input() garantia: GarantiasIdoneas;
  periodoGracia: GarantiasIdoneasPeriodoGracia;

  /** Listas */
  listGarantiasIdoneasPeriodoConcepto: GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] = [];
  conceptoFacturacion: SelectItem[];
  allConceptoFacturacion: ConceptoFacturacion[];

  lisTiposPeriodoGracia: ListaItem[] = [];
  lisTiposPeriodoGraciaTodos: SelectItem[] = [];


  columnas: any[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  indicadorConpeptos = false;
  edit = false;
  @ViewChild('dt') tabla: Table;
  opcion = false;
  tabSeleccionado = 'TABPERIDO';
  rangoMininoValido = true;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private confirmacionServicio: ConfirmationService,
    private periodoGraciaService: GarantiaIdoneasPeriodoGraciaService,
    private periodoGraciaConceptosService: GarantiaIdoneasPeriodoGraciaConceptosFacturacionService,
    private conceptoFacturacionService: ConceptoFacturacionService,

  ) {
  }

  ngOnInit() {

    if ( this.garantia && (this.garantia.idGarantiaIdonea !== '' && this.garantia.idGarantiaIdonea !== null && this.garantia.idGarantiaIdonea !== undefined) ) {
      /** Se carga garantias Servicios */
      forkJoin(
        this.periodoGraciaService.listadoPorPeriodoGracia( this.garantia.idGarantiaIdonea ),
        this.periodoGraciaConceptosService.listadoPorPeriodoConpecto( this.garantia.idGarantiaIdonea ),
        this.conceptoFacturacionService.listadoHabilitados(),
        this.lisServicio.getMasterDetails( 'ListasTiposPeriodoGracia' )
      ).subscribe( ( [ periodo, periodoConcepto, conceptos, lista ] ) => {
        this.periodoGracia = periodo;
        this.listGarantiasIdoneasPeriodoConcepto = periodoConcepto;
        this.allConceptoFacturacion = conceptos;

        this.lisTiposPeriodoGracia = lista;
        lista.map( ( s: ListaItem ) => {
          this.lisTiposPeriodoGraciaTodos.push( { label: s.nombre, value: s.idLista } );
        } );

        this.cargarInformacionInicial();
        if ( periodo ) {
          this.edit = true;
        }

      } );
    }

  }

  get getGarantiasIdoneasPeriodoConcepto() {
    return this.listGarantiasIdoneasPeriodoConcepto.filter( s => s.indicadorHabilitado );
    this.carTabla = false;
  }


  cargarInformacionInicial() {

    this.carTabla = false;
    this.columnas = [
      { field: 'codigoConceptoFacturacion', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOSCODIGO' ), sort: true },
      { field: 'conceptoFacturacion', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOSNOMBRE' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idGarantiaIdoneaPeriodoGracia : [ this.periodoGracia ? this.periodoGracia.idGarantiaIdoneaPeriodoGracia : null ],
      idGarantiaIdonea: [ this.garantia ? this.garantia.idGarantiaIdonea : null ],
      periodoMaximo: [ this.periodoGracia ? this.periodoGracia.periodoMaximo : null, [ Validators.required ] ],
      indicadorIntereses: [ this.periodoGracia ? this.periodoGracia.indicadorIntereses : false],
      indicadorCapital: [ this.periodoGracia ? this.periodoGracia.indicadorCapital : false],
      indicadorOtrosConceptos: [ this.periodoGracia ? this.periodoGracia.indicadorOtrosConceptos : false],
      indicadorHabilitado: [ true ],
      indicadorOpcional: [ this.periodoGracia ? this.periodoGracia.indicadorOpcional : false],
      periodoMinimo: [ this.periodoGracia ? this.periodoGracia.periodoMinimo : 0 ],
      idTipoPeriodoGracia: [ this.periodoGracia ? this.periodoGracia.idTipoPeriodoGracia : null, [ Validators.required ]  ],
    } );

    this.formularioConceptos = this.fb.group( {
      idGarantiaIdoneaPeriodoGracia : [ this.periodoGracia ? this.periodoGracia.idGarantiaIdoneaPeriodoGracia : null ],
      conceptos: [ [] ],
    } );
    if (this.periodoGracia && this.periodoGracia.indicadorOtrosConceptos) {
      this.indicadorConpeptos = true;
    }
    if (this.periodoGracia && this.periodoGracia.indicadorOpcional) {
      this.opcion = true;
    }
    this.carInformacionInicial = false;
    this.carDropdown();
  }

  get f() {
    return this.formulario.controls;
  }

  get c() {
    return this.formularioConceptos.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && this.rangoMininoValido) {
      this.guardando = true;
      const temp: GarantiasIdoneasPeriodoGracia = this.formulario.value;
      if ( temp.idGarantiaIdoneaPeriodoGracia !== '' && temp.idGarantiaIdoneaPeriodoGracia !== null && temp.idGarantiaIdoneaPeriodoGracia !== undefined ) {
        this.periodoGraciaService.actualizar(temp).subscribe( per => {
          this.periodoGracia = per;
          this.submitted = false;
          this.guardando = false;
          this.validacionConpeptos();
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_REGGUAR' )
          } );
        });
      } else {
        this.periodoGraciaService.crear(temp).subscribe( per => {
          this.periodoGracia = per;
          this.f.idGarantiaIdoneaPeriodoGracia.setValue( this.periodoGracia.idGarantiaIdoneaPeriodoGracia);
          this.edit = true;
          this.submitted = false;
          this.guardando = false;
          this.validacionConpeptos();
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_REGGUAR' )
          } );
        });
      }
    } else {
      return;
    }
  }


  insertaConceptos(){
    const forData = this.formularioConceptos.value;
    const tempGarantiasPeriodoConcepto: GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] = [];
    forData.conceptos.forEach(concepto => {
      let temp = {} as GarantiasIdoneasPeriodoGraciaConceptoFacturacion;
      temp.idGarantiaIdoneaPeriodoGracia = this.periodoGracia.idGarantiaIdoneaPeriodoGracia;
      temp.idConceptoFacturacion = concepto;
      temp.indicadorHabilitado = true;
      const a = this.listGarantiasIdoneasPeriodoConcepto.
      find( sp => sp.idConceptoFacturacion === temp.idConceptoFacturacion );
      if ( a ) {
        temp.idGarantiaIdoneaPGConceptoFacturacion = a.idGarantiaIdoneaPGConceptoFacturacion;
      }
      tempGarantiasPeriodoConcepto.push(temp);
    });

    if(this.periodoGracia.indicadorOtrosConceptos){
      this.periodoGraciaConceptosService.bulk( tempGarantiasPeriodoConcepto ).subscribe( res => {
        const tempSegmentoP: GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] = this.listGarantiasIdoneasPeriodoConcepto;
        this.listGarantiasIdoneasPeriodoConcepto = [];
        res.map(re => {
          re.codigoConceptoFacturacion = this.allConceptoFacturacion.find( p => p.idConceptoFacturacion
            === re.idConceptoFacturacion ).codigo;
          re.conceptoFacturacion = this.allConceptoFacturacion.find( p => p.idConceptoFacturacion
            === re.idConceptoFacturacion ).nombre;
          tempSegmentoP.map( t => {
            if ( t.idGarantiaIdoneaPGConceptoFacturacion === re.idGarantiaIdoneaPGConceptoFacturacion ) {
              t.indicadorHabilitado = true;
            }
          } );
          if(!tempSegmentoP.find(di => di.idGarantiaIdoneaPGConceptoFacturacion ===  re.idGarantiaIdoneaPGConceptoFacturacion)){
            tempSegmentoP.push(re);
          }
        });
        this.listGarantiasIdoneasPeriodoConcepto = tempSegmentoP;
        this.carDropdown();
        this.submitted = false;
        this.guardando = false;
        this.formularioConceptos.reset();
        this.navServicio.setMesage( 0, {
          severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_REGGUAR' )
        } );
      } );
    }
  }

  disable( row: GarantiasIdoneasPeriodoGraciaConceptoFacturacion ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Garantías idóneas Conceptos',
      icon: 'fa fa-question-circle',
      key: 'garantia-idoneas-concepto',
      accept: () => {
        row.indicadorHabilitado = false;
        this.periodoGraciaConceptosService.actualizar( row ).subscribe( res => {
          const temp: GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] = this.listGarantiasIdoneasPeriodoConcepto;
          this.listGarantiasIdoneasPeriodoConcepto = [];
          temp.map( t => {
            if ( t.idGarantiaIdoneaPGConceptoFacturacion === row.idGarantiaIdoneaPGConceptoFacturacion ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.listGarantiasIdoneasPeriodoConcepto = temp;
          this.carDropdown();
        } );
      }
    } );
  }


  carDropdown(): void {
    this.conceptoFacturacion = [];
    this.allConceptoFacturacion.map( p => {
      if ( p.indicadorHabilitado && !this.listGarantiasIdoneasPeriodoConcepto.find( sp =>
        sp.indicadorHabilitado && sp.idConceptoFacturacion === p.idConceptoFacturacion ) ) {
        this.conceptoFacturacion.push( { label: p.nombre, value: p.idConceptoFacturacion } );
      }
    } );
  }

  validacionConpeptos(){
    if (this.f.indicadorOtrosConceptos.value) {
      this.indicadorConpeptos = true;
    } else {
      this.indicadorConpeptos = false;
    }
  }

  validarOpcion(){
    if (this.f.indicadorOpcional.value) {
      this.opcion = true;
      this.f.periodoMinimo.setValidators( [ Validators.required ] );
      this.f.periodoMinimo.updateValueAndValidity();
    } else {
      this.opcion = false;
      this.f.periodoMinimo.setValue(0);
      this.f.periodoMinimo.setValidators( [ ] );
      this.f.periodoMinimo.updateValueAndValidity();
    }
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'TABPERIDO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'TABCONCEPTOS';
        break;
      }
      default: {
        break;
      }
    }
  }

  onSubmitConpetos() {
    this.submitted = true;
    if ( this.formularioConceptos.valid ) {
      this.insertaConceptos();
    }
  }

  validarPlazos() {
    let periodoMinimo = this.f.periodoMinimo.value;
    let periodoMaximo = this.f.periodoMaximo.value;
    if (Number(periodoMinimo) > Number(periodoMaximo)) {
      this.rangoMininoValido = false;
    } else {
      this.rangoMininoValido = true;
    }
  }



  }
